import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

import { corePrintKbaseLinks } from './links/corePrintKbaseLinks'
import { lfKbaseLinks } from './links/lfKbaseLinks'
import { personalSystemsKbaseLinks } from './links/personalSystemsKbaseLinks'
import { printing3d } from './links/printing3dKbaseLinks'

export const kbaseLinks = {
  [ProgramTypes.CorePrint]: corePrintKbaseLinks,
  [ProgramTypes.PersonalSystems]: personalSystemsKbaseLinks,
  [ProgramTypes.Printing3D]: printing3d,
  [ProgramTypes.LargeFormat]: lfKbaseLinks,
}
